export const ACTIVE_STATUSES = [
  'Active',
  'Activated',
  'RedeemPending',
];
